import qs from 'qs';

import { envDomain } from '@itm/shared-frontend/lib/utils';
import { LoadingButton } from '@itm/shared-frontend/lib/components/buttons';

import { AUTH_API_URL } from 'src/utils/constants';

import { MicrosoftIcon } from 'src/components/icons';

function SsoMicrosoftButton() {
  const handleSsoLogin = () => {
    // Redirect to SSO Init endpoint which will redirect to Azure AD
    globalThis.location.href = `${AUTH_API_URL}/auth/sso/initiate/azure?${qs.stringify({ domain: envDomain })}`;
  };
  return (
    <LoadingButton
      type="button"
      className="button is-grey is-outlined is-fullwidth mb-3"
      onClick={handleSsoLogin}
      minTime={1000}
    >
      <span className="icon">
        <MicrosoftIcon />
      </span>
      <span>Sign in with Microsoft</span>
    </LoadingButton>
  );
}

export default SsoMicrosoftButton;
